<script>
import appConfig from '@src/app.config'
import '@fontsource/roboto'
import { isAuthExpiredError, redirectToLoginForAuth, routeRequiresAuth } from '@utils/auth-session'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  computed: {
    adminAuthError() {
      return this.$store.getters['auth/adminAuthError']
    },
  },
  watch: {
    adminAuthError(value) {
      if (value) {
        this.redirectToLoginForExpiredSession()
      }
    },
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    handleVisibilityChange() {
      if (document.hidden || !routeRequiresAuth(this.$route) || !this.$store.getters['auth/loggedIn']) {
        return
      }

      this.validateVisibleSession()
    },
    async validateVisibleSession() {
      try {
        const token = await this.$store.dispatch('auth/validate')

        if (!token) {
          await this.redirectToLoginForExpiredSession({ showMessage: !!this.adminAuthError })
        }
      } catch (error) {
        if (isAuthExpiredError(error)) {
          await this.redirectToLoginForExpiredSession({ showMessage: !!this.adminAuthError })
          return
        }

        this.debugLog(error)
      }
    },
    redirectToLoginForExpiredSession({ showMessage = true } = {}) {
      return redirectToLoginForAuth(this.$store, this.$router, undefined, { showMessage })
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
@import '~nprogress/nprogress.css';
@import '~vue-multiselect/dist/vue-multiselect.min.css';
@import '~shepherd.js/dist/css/shepherd.css';

// Design variables and utilities from src/design.
@import '@design';
@import 'app';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  @media (min-width: $lg-breakpoint) {
    padding-right: 0 !important;
    overflow-y: scroll;
  }

  margin-right: calc(-1 * (100vw - 100%));
  overflow-x: hidden;
  scrollbar-gutter: stable;
  background: $color-body-bg;
}

body.login {
  background: $primary-blue;
}

body.iframe {
  overflow-y: hidden;
}

// ===
// Vendor
// ===
#nprogress .bar {
  background: $primary-blue;
}
</style>
